pt({ "de": { "cmsf-branding": { "buttonLabel": "Basierend auf HubSpot", "dropdown": { "reportAbuse": "Missbrauch melden\n", "getCms": "Erstellen Sie Ihre eigene kostenlose Website" } } } });
export var translations;
function pt(t) { (translations = translations || []).push(t); }

